const sliderPictureArray = [
  {
    index: 0,
    img: "https://assets-in.bmscdn.com/promotions/cms/creatives/1730799832000_novhazariwitharrahman1240x300.jpg",
  },
  {
    index: 1,
    img: "https://assets-in.bmscdn.com/promotions/cms/creatives/1726036566435_playcardnewweb.jpg",
  },
  {
    index: 2,
    img: "https://assets-in.bmscdn.com/promotions/cms/creatives/1733319521966_amittandononelasttourbms1240x300v1.jpg",
  },
  {
    index: 3,
    img: "https://assets-in.bmscdn.com/promotions/cms/creatives/1733911700713_edwebgeneralsales.jpg",
  },
];

export default sliderPictureArray;
